import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "mfa-success-container" }
const _hoisted_2 = { id: "mfa-title" }
const _hoisted_3 = { id: "recovery-codes" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { id: "button-container" }

import Typography from '@/components/Rain/Typography/Typography.vue'

interface Props {
    isLoading: boolean
    codes: string[]
    fromMfaSetup: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MFASetupOk',
  props: {
    isLoading: { type: Boolean },
    codes: { default: Array as () => string[] },
    fromMfaSetup: { type: Boolean, default: false }
  },
  emits: ['onDownload', 'onDone'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[2] || (_cache[2] = _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: "/img/login/mfa-success.svg",
          width: "37",
          height: "39",
          alt: "success-icon"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Typography, {
          variant: "h4",
          component: "h4",
          class: "title-container"
        }, {
          default: _withCtx(() => [
            (_ctx.fromMfaSetup)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("MFA Successfully Setup")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Your Recovery Codes")
                ], 64))
          ], undefined, true),
          _: 1
        })
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "uk-width-1-1 uk-margin-top uk-margin-bottom uk-text-small" }, [
        _createElementVNode("p", null, [
          _createTextVNode(" If you lose access to your authenticator and need to log back in, below are your "),
          _createElementVNode("strong", null, "recovery codes"),
          _createTextVNode(". Please note that each code is one-time use. Download the codes and keep it in a safe place. ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Fetching recovery codes, please wait ..."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codes, (code, index) => {
          return (_openBlock(), _createElementBlock("code", { key: index }, _toDisplayString(code), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("a", {
        class: "uk-button button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onDownload')))
      }, "Download Recovery Codes"),
      _createElementVNode("a", {
        class: "uk-button button primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('onDone')))
      }, "Done")
    ])
  ]))
}
}

})